import { BillingPlanTier } from '@core/billing-types';
import type { IconToken } from '@core/user-interface-legacy';

export const billingPlanTokenRecord: Record<BillingPlanTier, IconToken> = {
  [BillingPlanTier.Launch]: 'colorIconScaleDefault',
  [BillingPlanTier.Scale]: 'colorIconScaleDefault',
  [BillingPlanTier.Lead]: 'colorIconScaleDefault',
  [BillingPlanTier.Start]: 'colorIconPrimaryDefault',
  [BillingPlanTier.Grow]: 'colorIconScaleDefault',
  [BillingPlanTier.Optimize]: 'colorIconLeadDefault',
};
